import { Classification, DocumentStatus, GenericObject, ReceiptAlert, copyFields, fixDates } from '@synergy/models';
import { Media } from '@synergy/models';

import { AccountPurchase } from './account-purchase';
import { Contact } from '../../../common/models/contact';
import { SupplierAccount } from './supplier-account';
import { User } from '../../../common/models/user';

export class Inquiry {
    public id!: number;
    public number!: string;
    public title!: string;
    public description?: string;
    public enableExpirationNotifications!: boolean;
    public commission?: string;
    public internalNote?: string;
    public noteToSupplier?: string;
    public noteToCustomer?: string;
    public status!: DocumentStatus;
    public accountPurchases!: AccountPurchase[];
    public supplierAccounts!: SupplierAccount[];
    /** Every supplier the inquiry went out to, once; only the list carries it. */
    public supplierNames?: string[];
    /** "Angebote x/y", per supplier; missing until the inquiry is sent (#2260). */
    public offerCount?: { asked: number; submitted: number; declined: number };
    /** Running for 21 days or longer; the server holds the rule (#2260). */
    public isLongOpen?: boolean;
    public responsibleContact?: Contact;
    public media!: Media[];
    public dueDate?: Date;
    public endDate?: Date;
    public isAuction?: boolean;
    public receiptAlert?: ReceiptAlert;
    public rating?: number;
    public classifications?: Classification[];

    public createdBy?: User;
    public updatedBy?: User;
    public createdAt!: Date;
    public updatedAt!: Date;

    public static fromPlainObject(object: GenericObject): Inquiry {
        const inquiry = new Inquiry();

        copyFields(object, inquiry);

        if (object['responsibleContact']) {
            inquiry.responsibleContact = Contact.fromPlainObject(object['responsibleContact']);
        }

        if (object['supplierAccounts']) {
            inquiry.supplierAccounts = object['supplierAccounts'].map(SupplierAccount.fromPlainObject);
        }

        if (object['createdBy']) {
            inquiry.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            inquiry.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        if (object['media']) {
            inquiry.media = object['media'].map(Media.fromPlainObject);
        }

        if (object['accountPurchases']) {
            inquiry.accountPurchases = object['accountPurchases'].map(AccountPurchase.fromPlainObject);
        }

        fixDates(inquiry, ['createdAt', 'dueDate', 'endDate', 'updatedAt']);

        return inquiry;
    }
}
